import styled from 'styled-components';

export const TitleWrapper = styled.div`
    padding-top: 1rem;
`;